// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3TYXF","additionalInfo":"AgreementModal_additionalInfo__3HAe4"};